import styled from "@emotion/styled";
import { Box, Typography, Button } from "@mui/material";
import { colors } from "../../../theme/colors";

export const ContentContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  padding: 32px 40px;
  max-height: 90vh;
  overflow-y: auto;
`;

export const ModalTitle = styled(Typography)`
  font-family: "Sora", sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: ${colors.text.primary};
  text-align: center;
  margin-bottom: 32px;
`;

export const FormContainer = styled(Box)`
  display: flex;
  gap: 24px;
`;

export const FormColumn = styled(Box)`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const ColumnTitle = styled(Typography)`
  font-family: "Nunito", sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: ${colors.text.primary};
  margin-bottom: 8px;
`;

export const FieldContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const FieldLabel = styled(Typography)`
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: ${colors.text.secondary};
`;

export const RequiredMark = styled.span`
  color: inherit;
`;

export const StyledInput = styled.input<{ hasError?: boolean }>`
  width: 100%;
  height: 44px;
  padding: 0 16px;
  border: 1px solid
    ${({ hasError }) => (hasError ? colors.status.error : colors.border.light)};
  border-radius: 8px;
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  color: ${colors.text.primary};
  background-color: ${colors.background.secondary};
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: ${({ hasError }) =>
      hasError ? colors.status.error : colors.primary.main};
  }

  &::placeholder {
    color: ${colors.text.secondary};
  }

  &:disabled {
    background-color: ${colors.background.default};
    cursor: not-allowed;
  }
`;

export const PhoneInputWrapper = styled(Box)`
  /* Match StyledInput appearance: 1px border, no red background in error state */
  & > div > div {
    border-width: 1px !important;
    background-color: ${colors.background.secondary} !important;
  }
`;

export const ErrorText = styled(Typography)`
  font-family: "Nunito", sans-serif;
  font-size: 12px;
  color: ${colors.status.error};
  margin-top: 4px;
`;

export const ButtonsContainer = styled(Box)`
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-top: 32px;
`;

export const CancelButton = styled(Button)`
  min-width: 120px;
  height: 44px;
  border: 1px solid ${colors.primary.main};
  color: ${colors.primary.main};
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  font-weight: 700;
  text-transform: none;
  border-radius: 8px;
  background-color: transparent;

  &:hover {
    background-color: ${colors.background.lightBlue};
    border-color: ${colors.primary.main};
  }
`;

export const SubmitButton = styled(Button)`
  min-width: 120px;
  height: 44px;
  background-color: ${colors.amber.main};
  color: #ffffff;
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  font-weight: 700;
  text-transform: none;
  border-radius: 8px;
  box-shadow: none;

  &:hover {
    background-color: ${colors.amber.dark};
    box-shadow: none;
  }

  &:disabled {
    background-color: ${colors.border.light};
    color: ${colors.text.secondary};
  }
`;
